import { z } from "zod";

export const UpdateBasketDeadlineSchema = z.object({
  date: z.date(),
});
